import { render, staticRenderFns } from "./InboundShipments.vue?vue&type=template&id=94610158&"
import script from "./InboundShipments.vue?vue&type=script&lang=js&"
export * from "./InboundShipments.vue?vue&type=script&lang=js&"
import style0 from "./InboundShipments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports